var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Component } from '../../../lib/dom';
import { Entry } from './Entry';
import './Pedestal.less';
var Pedestal = /** @class */ (function (_super) {
    __extends(Pedestal, _super);
    function Pedestal(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Pedestal';
        _this.el = _this.DIV('&');
        _this.clear();
        return _this;
    }
    Pedestal.prototype.setEntries = function (entries, userRank) {
        while (entries.length < 3 && userRank !== undefined) {
            entries.push({
                rank: entries.length + 1,
                score: '---',
                player: { publicName: ' ', avatar: require('./img/anonymous.png'), getAvatarSrcSet: function () { return ''; } },
            });
        }
        this.el.appendChild(this.DIV('&__entries', this.mapEntries(entries, userRank)), true);
    };
    Pedestal.prototype.clear = function () {
        this.setEntries([]);
    };
    Pedestal.prototype.mapEntries = function (entries, userRank) {
        entries.sort(function (a, _b) {
            if (a.rank === 2)
                return -1;
            if (a.rank === 3)
                return 1;
            return 0;
        });
        return __spreadArray([], entries.map(function (entry, _index) {
            return new Entry({
                active: entry.rank === userRank,
                border: false,
                entry: entry,
                splitName: true,
            });
        }), true);
    };
    return Pedestal;
}(Component));
export { Pedestal };
